var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150,5C70,5,5,70,5,150s65,145,145,145s145-65,145-145S230,5,150,5z M150,281.2c-72.3,0-131.2-58.9-131.2-131.2 S77.7,18.8,150,18.8S281.2,77.7,281.2,150S222.3,281.2,150,281.2z M210.7,81H89.3c-10.7,0-19.4,8.7-19.4,19.4 c0,0,0.1,84.5,0.1,114.3c0,3.8,4.6,5.7,7.2,3l26.8-26.8h106.7c10.7,0,19.4-8.7,19.4-19.4v-71.1C230.1,89.7,221.4,81,210.7,81z  M197.5,149.8c-0.8,0.8-1.9,1.3-3.2,1.3h-86.7c-2.5,0-4.5-2-4.5-4.5c0-1.2,0.5-2.4,1.3-3.2c0.8-0.8,1.9-1.3,3.2-1.3h86.7 c2.5,0,4.5,2,4.5,4.5C198.8,147.8,198.3,149,197.5,149.8z M197.5,125.2c-0.8,0.8-1.9,1.3-3.2,1.3h-86.7c-2.5,0-4.5-2-4.5-4.5 c0-1.2,0.5-2.4,1.3-3.2c0.8-0.8,1.9-1.3,3.2-1.3h86.7c2.5,0,4.5,2,4.5,4.5C198.8,123.2,198.3,124.4,197.5,125.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.03c3e716ff5ad082277df5aa4db7bca7.svg";
export { ForwardRef as ReactComponent };